export default __webpack_public_path__ + "static/media/26.19c2ee71.jpg";